import { DynamicFieldType } from "../../enumerators/dynamic-field.enum";
import { ColumnTemplateType as ColumnTemplateType } from "../../enumerators/column-template.enum";
import { ColumnDataType as ColumnDataType } from "src/app/enumerators/column-data.enum";

export class DynamicColumn<T> {
    format?: string;
    type?: DynamicFieldType;
    label?: string;
    property?: keyof T | string;
    group?: number;
    groupBy?: number;
    filter?: boolean;
    sort?: boolean;
    dataType?: ColumnDataType | null;
    template?: ColumnTemplateType;
    allowExporting?: boolean;
    aligment?: 'center' | 'left' | 'right';
    fixed?: boolean;
    width?: number;
    groupIndex?: number;
    sortIndex?: number;
    visible?: boolean;

    constructor(source: Partial<DynamicColumn<T>>) {
        this.aligment = 'center';
        this.groupIndex = -1;
        Object.assign(this, source);
    }
}